import { config } from "../../../app-confi/app-config";
import { columnType } from "./models/column-type.enum";
import { columnBays } from "./models/column-types.model";
import { PropsRowhouse } from "./models/props-config";

export class RowhouseService {

    static getAmountsByAvailableBays(p: PropsRowhouse): {
        amount_H_S_Columns: number,
        amount_H_M1M2_Columns: number,
        amount_H_L_Columns: number
    } {
        const bays_H_S = columnBays.find(c => c.type === columnType.H_S).bays;
        const bays_H_M1M2 = columnBays.find(c => c.type === columnType.H_M1M2).bays;
        const bays_H_L = columnBays.find(c => c.type === columnType.H_L).bays;

        let availableBays = RowhouseService.getBodySizeForCalculation(p);

        let amount_H_S = 0;
        let amount_H_M1M2 = 0;
        let amount_H_L = 0;
        let result: any = {};
        if (availableBays > 0) {
            const removeBays = () => {
                availableBays -= bays_H_S;
                if (availableBays > 0) {
                    amount_H_S++;
                    availableBays -= bays_H_M1M2;
                    if (availableBays > 0) {
                        amount_H_M1M2++;
                        availableBays -= bays_H_L;
                        if (availableBays > 0) {
                            amount_H_L++;
                            removeBays();
                        }
                    }
                }
            }
            removeBays();
            result.amount_H_S_Columns = amount_H_S;
            result.amount_H_M1M2_Columns = amount_H_M1M2;
            result.amount_H_L_Columns = amount_H_L;
        } else {
            result.amount_H_S_Columns = 0;
            result.amount_H_M1M2_Columns = 0;
            result.amount_H_L_Columns = 0;
        }
        return result;
    }


    static getTotalBays(p: PropsRowhouse) {
        return Math.ceil(p.buildingLength / config.rowhouseBaySize);
    }

    static getBodySizeForCalculation(p: PropsRowhouse) {
        let bodySize = RowhouseService.getTotalBays(p);
        return bodySize > 0 ? bodySize : 0;
    }

    static getBodySizeForComputationBasedOnColumnsAmount(p: PropsRowhouse) {
        return p.amount_H_S_Columns * columnBays.find(c => c.type === columnType.H_S).bays +
            p.amount_H_M1M2_Columns * columnBays.find(c => c.type === columnType.H_M1M2).bays +
            p.amount_H_L_Columns * columnBays.find(c => c.type === columnType.H_L).bays;
    }
}